const SELECTORS = {
  panel: "[data-fd-panel]",
  backdrop: "[data-fd-backdrop]",
  close: "[data-fd-close]",
  trigger: "[data-filter-drawer-trigger]",
};

const OPEN_CLASS = "is-open";

class FilterDrawer extends HTMLElement {
  constructor() {
    super();
    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onBackdropClick = this.onBackdropClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    try {
      this.#bind();
    } catch (error) {
      console.error("[FilterDrawer:connect]", error);
    }
  }

  #bind() {
    this.panel = this.querySelector(SELECTORS.panel);
    this.backdrop = this.querySelector(SELECTORS.backdrop);
    this.closeBtn = this.querySelector(SELECTORS.close);

    if (!this.panel) {
      throw new Error("[FilterDrawer] Missing [data-fd-panel]");
    }

    this.triggers = document.querySelectorAll(
      `${SELECTORS.trigger}[data-filter-drawer-trigger="${this.id}"]`,
    );
    this.triggers.forEach((t) => t.addEventListener("click", this.onTriggerClick));

    if (this.backdrop) this.backdrop.addEventListener("click", this.onBackdropClick);
    if (this.closeBtn) this.closeBtn.addEventListener("click", this.onCloseClick);
    document.addEventListener("keydown", this.onKeydown);
  }

  disconnectedCallback() {
    this.triggers?.forEach((t) => t.removeEventListener("click", this.onTriggerClick));
    this.backdrop?.removeEventListener("click", this.onBackdropClick);
    this.closeBtn?.removeEventListener("click", this.onCloseClick);
    document.removeEventListener("keydown", this.onKeydown);
  }

  open() {
    this.classList.add(OPEN_CLASS);
    this.#setTriggerExpanded(true);
    document.documentElement.style.overflow = "hidden";
  }

  close() {
    this.classList.remove(OPEN_CLASS);
    this.#setTriggerExpanded(false);
    document.documentElement.style.overflow = "";
  }

  #setTriggerExpanded(value) {
    this.triggers?.forEach((t) => t.setAttribute("aria-expanded", String(value)));
  }

  onTriggerClick(event) {
    event.preventDefault();
    if (this.classList.contains(OPEN_CLASS)) {
      this.close();
    } else {
      this.open();
    }
  }

  onBackdropClick() {
    this.close();
  }

  onCloseClick() {
    this.close();
  }

  onKeydown(event) {
    if (event.key === "Escape" && this.classList.contains(OPEN_CLASS)) {
      this.close();
    }
  }
}

if (!customElements.get("filter-drawer")) {
  customElements.define("filter-drawer", FilterDrawer);
}
